import { api } from '@/lib/api'

export type ControlAccounts = {
  ar_code: string
  ap_code: string
  cash_code: string
  sales_returns_code: string
  bad_debt_code: string
  tax_receivable_code: string
  sales_tax_payable_code: string
  retained_earnings_code: string
}

export const controlAccountsApi = {
  get: () => api.get<{ control_accounts: ControlAccounts }>('/api/accounting/control-accounts'),
  patch: (patch: Partial<ControlAccounts>) =>
    api.patch<{ control_accounts: ControlAccounts }>('/api/accounting/control-accounts', patch),
}
